import React from 'react';
import './footer.style.css'

const Footer = () => (
  <div>
    <footer className="footer">
      <div className="responsive-legal-copyright">
        <p>
          © {new Date().getFullYear()} Sophos Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  </div>
);

export default Footer;
